import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { NotificationPreferencePageComponent } from './notification-preference-page.component';
import { FormsModule } from '@angular/forms';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.notificationpreference',
    url: '/notificationpreference',
    component: NotificationPreferencePageComponent,
    data: {
      requireLogin: true
    },
    params: {
      userId: null
    }
  }
];

@NgModule({
  declarations: [NotificationPreferencePageComponent],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [NotificationPreferencePageComponent],
  entryComponents: [NotificationPreferencePageComponent]
})
export class NotificationPreferencePageModule { }
